import React from 'react';
import {Flex} from "../common_style/flex";
import {Colors, FontStyles} from "../constants";
import styled from 'styled-components';
import {Span} from "../common_style/text";
import {ReactComponent as Plus} from "../../assets/icons/add_page.svg";
import {ReactComponent as Delete} from "../../assets/icons/delete.svg";
import {Localization} from "localizations/languages";

const CardContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 350px;
    min-height: 196px;
    background-image: url("${props => props.bgImage}");;
    background-size: cover;
    margin: 0 25px 25px 25px;
    cursor:pointer;
`;

const CircleDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  width: 70px;
  height: 70px;
  border: 2px solid ${Colors.button};
`;

export function NewPageCardView(props) {
    return <CardContainer onClick={() => props.onClick()}>
        <Flex column hAlign={'center'} vAlign={'center'}>
            <CircleDiv>
                <Plus style={{height: '45px'}}/>
            </CircleDiv>
            <Span textStyle={FontStyles.button} style={{marginTop: 10}}>{Localization.current.translation16}</Span>
        </Flex>
    </CardContainer>
}

const iconStyle = {
    filter: 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))', width: '20px', height: '20px', fill: 'white'
};

function PageCardView(props) {
    return <CardContainer onClick={() => props.onClick()} {...props} style={{backgroundColor: 'white', ...props.style}}>
        {!!props.onDelete ? <div
            onClick={(e) => {
                e.stopPropagation();
                props.onDelete();
            }}
            style={{
                position: 'absolute',
                top: 20,
                right: 20,
            }}>
            {props.isCover ? null : <Delete style={iconStyle}/>}
        </div> : null}
    </CardContainer>
}

export default PageCardView;